module.exports = __webpack_public_path__ + "static/img/back.016950f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/back.jpg
// module id = b6SF
// module chunks = 4